<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div ref="scrollElement" :class="containerStyles">
    <rich-text
      :text="content"
      :isUmbraco="isUmbraco"
      :theme="themeType"
      classes="col-start-2 col-span-12 md:col-start-5 md:col-span-6"
    />
  </div>
</template>

<script lang="ts" setup>
import RichText from "@components/Typography/RichText.ce.vue";
import { Theme } from "@/types/types";
import { computed, onMounted, toRefs, ref, Ref, onUnmounted, watch } from "vue";
import { changeTheme, getThemeType } from "@/util/helper";
import { onIntersect } from "@/composables/onIntersect";

const props = withDefaults(
  defineProps<{
    content: string;
    isUmbraco?: boolean;
    theme?: Theme;
  }>(),
  { isUmbraco: false, theme: "sand" }
);

const { content, isUmbraco, theme } = toRefs(props);

const observer: Ref<IntersectionObserver | null> = ref(null);
const scrollElement = ref(null);

const onEnter = () => {
  changeTheme(theme.value);
};
const onExit = () => {};

onMounted(() => {
  observer.value = onIntersect(scrollElement.value, onEnter, onExit, false, {
    threshold: 0.1,
  });
});

onUnmounted(() => {
  if (!observer.value) return;
  observer.value.disconnect();
});

watch(theme, (value) => {
  if (!value) return;
  changeTheme(value);
});

const themeType = computed(() => {
  return getThemeType(theme.value);
});

const containerStyles = computed(() => {
  const bgColor = isUmbraco.value ? `bg-${theme.value}` : ``;
  return `${bgColor} sectionContainer lg:min-h-full py-10 py-[60px]`;
});
</script>
